import { createFileRoute } from '@tanstack/react-router'
import { MatchExistingAsset } from '@/components/installFlowV2/match-existing-asset'
import { z } from 'zod'

export const Route = createFileRoute('/installFlow/match-existing-asset')({
  component: MatchExistingAsset,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
})

